<template>
  <Component
    :is="tag"
    :to="link"
    class="article-tag t-p-s-130"
    :class="[
      {
        'article-tag--selected': selected,
        clear: clear
      }
    ]"
  >
    <Close class="icon icon--18" />
    {{ text }}
  </Component>
</template>

<script setup lang="ts">
import type { RouteLocationRaw } from 'vue-router'

import Close from '@/assets/icons/close.svg?component'

const props = withDefaults(
  defineProps<{
    text: string
    clear?: boolean
    selected?: boolean
    link?: RouteLocationRaw
  }>(),
  {
    clear: false,
    selected: false,
    link: undefined
  }
)

const tag = computed(() => {
  if (props.link) return resolveComponent('NuxtLink')
  return 'span'
})
</script>

<style lang="scss" scoped>
.icon {
  margin-inline: rem(16px);
  color: $layout-text-02;
}

.article-tag {
  @include center-content;
  height: rem(44px);
  padding: rem(13px) rem(22px);
  color: $layout-text-02;
  border: 1px solid $global-grey-04;
  border-radius: rem(50px);

  &--selected {
    border-color: $layout-text-02;
  }

  .icon {
    display: none;
  }
}

.clear {
  padding: 0;
  margin-block: auto;
  margin-left: rem(12px);
  border: 0;
  border-left: 1px solid $global-grey-04;
  border-radius: 0;

  .icon {
    display: flex;
  }
}
</style>
